module.exports = __webpack_public_path__ + "img/linkedin.cf8483d6.svg";